import { ReactNode } from 'react'
import { Banner } from '@/components/banner'
import { cn } from '@/utils/styles/cn'

export const CommonLogosBanner = ({
    items,
    className,
}: {
    items: ReactNode[]
    className?: string
}) => {
    return (
        <Banner
            className={cn('md:pb-6 md:py-2', className)}
            items={items}
            innerContainerClassName="items-center"
        />
    )
}
